// import { useContext } from 'react';
import { interpret } from 'xstate';
import { dryFetch } from '../../utils/dryFetch';
import { getOwnerID } from '../../utils/DryCookies';
// import track from '../utils/trackers';
// import { writeUserSettings, writeSystemValue } from '../offline/';
import logger from '../../logger';

export const fetchUserSettingsFromCloud = async () => {
  const ownerID = getOwnerID();
  // const userSettingsAppState = interpret(userSettingsMachine, { devTools: true }).start();
  // const [ userSettingsState, userSettingsStateSend ] = useActor(globalServices.userSettings);
  // track.startTime('fetchUserSettings');

  // Update the state that we started the request for user settings

  try {
    const userSettingsJson = await dryFetch({
      name: 'fetchUserSettings',
      path: `/user-settings/${ownerID}`,
    });
    // const completedTime = track.endTime('fetchUserSettings');
    // logger.info({
    //   ownerID,
    //   time: completedTime,
    // }, 'fetchUserSettings time');
    // track.time({
    //   category: 'user_settings',
    //   name: 'fetch_user_settings',
    //   value: completedTime,
    //   label: '',
    // });
    const userSettings = userSettingsJson.result;

    // Write to the user settings state machine
    // userSettingsAppState.send({ type: 'HYDRATE_USER_SETTINGS', data: userSettings });
    if (false) {
      await writeUserSettings({ userSettings });
      await writeSystemValue({
        name: 'userSettings',
        utcDateTime: userSettings.utcDateTime,
      });
    }

    return userSettings;
  } catch (error) {
    logger.error(error);
    throw error;
  }
};

export const saveUserSettings = async ({ property, payload }) => {
  try {
    // const ownerJWT = getOwnerJWT();
    // const myHeaders = new Headers();
    // myHeaders.append('Authorization', `Bearer ${ownerJWT}`);

    const response = await dryFetch({
      name: 'saveUserSettings',
      path: `/user-settings/properties/${property}`,
      options: {
        method: 'PATCH',
        body: JSON.stringify(payload),
      },
    });

    const userSettings = await response;
    return userSettings;
  } catch (error) {
    logger.error(error);
    throw error;
  }
};
